define(
    'LNRS/Components/Charts/gauge',["jquery", "d3", "scrollMagic", "mustache", "LNRS/Components/Charts/Base"],
    function ($, d3, ScrollMagic, mustache, Base) {
        "use strict";

        function GaugeChart(scope, chartInfo, id) {
            Base.call(this, scope, chartInfo, id);
        }

        GaugeChart.prototype = Object.create(Base.prototype);

        GaugeChart.prototype.initChart = function initChart(gDiv, dataset) {
            var svgWidth = $(gDiv).width();
            var svgHeight = svgWidth /3  + 75;

            if (svgHeight < 150) {
                svgHeight = 145;
                $(gDiv).css('padding-bottom','150px');
                $(gDiv).css('height','1px');
            } else {
                $(gDiv).css('padding-bottom','calc(35% + 75px)');
                $(gDiv).css('height','1px');
            }


            var svg = d3.select(gDiv)
                .append('svg')
                .attr('viewBox', '0,0,'+ svgWidth + ','+ svgHeight )
                .style('pointer-events', 'none');

            // shadow for tooltip
            var chartDefs = svg.append('defs');
            var chartFilter = chartDefs.append('filter')
                .attr('id','shadow')
                .attr('x','0')
                .attr('y','0');
            chartFilter.append('feOffset')
                .attr('result','offOut')
                .attr('in','SourceAlpha')
                .attr('dx','-5')
                .attr('dy','-5');
            chartFilter.append('feGaussianBlur')
                .attr('result','blurOut')
                .attr('in','offOut')
                .attr('stdDeviation','6');
            chartFilter.append('feBlend')
                .attr('in','SourceGraphic')
                .attr('in2','blurOut')
                .attr('mode','normal');
        }

        GaugeChart.prototype.animateChart = function animateChart(gDiv, dataset) {

            var zoneAngles = [-65, -20, 20, 65];
            var format = d3.format(".0f");
            var zoneColors = ["#ED1C24","#FF8200","#E1CD00","#00AF66"]
            var lnrsGray = "#666";
            var minAngle = -90;
            var svg = d3.select(gDiv + " svg");
            var i;

            var div = d3.select(gDiv).append("div").attr("class", "tooltip-c");
            //
            var gaugeWidth = 10;
            var gaugeBorder = 4;
            // init svg
            var svgWidth = $(gDiv).width();
            var svgHeight = svgWidth /3 + 75;
            if ( svgWidth < 150 ) {
                svgHeight = 135;
            }


            var margin = { top: 5, right: 5, bottom: 5, left:5 },
                chartWidth  = svgWidth  - margin.left - margin.right,
                chartHeight = svgHeight - margin.top  - margin.bottom;    
    
            var chartWrapper = svg.append('g')
                .style('font-family',"'Source Sans Pro'")
                .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

            // hide all untill it's their time
            chartWrapper
                .attr('opacity','0')
                .transition()
                .delay(1200 * (dataset.delayIndex))
                .duration(300)
                .attr('opacity','1')
                
            //do the setup
            var numberRadius = 35;

            var radius = chartWidth/3;
            if (radius < 50 ) radius = 70;
            var centerPoint = [chartWidth/2, radius + 20];
            // pointer
            var pointerWidth = 8;
            var pointerHeadLength = radius + 10;
            var pointerTailLength = 6;    
    
            var lineData = [ 
                [pointerWidth / 2, 0], 
                [0, -pointerHeadLength],
                [-(pointerWidth / 2), 0],
                [0, pointerTailLength],
                [pointerWidth / 2, 0] 
                ];
            var pointerLine = d3.line();
    
    
            var fgArc1 = d3.arc()
                .innerRadius(radius -gaugeWidth -gaugeBorder)
                .outerRadius(radius )
                .startAngle(-Math.PI / 2)
                .endAngle(- Math.PI / 4);

            var fgArc2 = d3.arc()
                .innerRadius(radius -gaugeWidth -gaugeBorder)
                .outerRadius(radius )
                .startAngle(-Math.PI / 4)
                .endAngle(0);

            var fgArc3 = d3.arc()
                .innerRadius(radius -gaugeWidth -gaugeBorder)
                .outerRadius(radius )
                .startAngle(0)
                .endAngle(Math.PI / 4);

            var fgArc4 = d3.arc()
                .innerRadius(radius -gaugeWidth -gaugeBorder)
                .outerRadius(radius )
                .startAngle(Math.PI / 4)
                .endAngle(Math.PI / 2);
                
            // all gray - background
            var fgArcAll = d3.arc()
                .innerRadius(radius -gaugeWidth -gaugeBorder)
                .outerRadius(radius )
                .startAngle(-Math.PI / 2)
                .endAngle(Math.PI / 2);
    
            var p0 = chartWrapper.append('g')
                    .attr('class', 'graph0')
                    .attr('transform','translate(' + centerPoint + ')');
            
            p0.append('path')
                .attr("d",fgArcAll)
                .attr("fill", "#666")
                .attr("stroke", "#666")
                .attr("stroke-width",gaugeBorder);
            
            p0.append('path')
                    .attr("d",fgArc1)
                    .attr("fill", zoneColors[0])
                    .attr("stroke", "#666")
                    .attr("stroke-width",gaugeBorder)
                    .attr('opacity','0')
                    .transition()
                    .duration(300)
                    .delay(1200 * (dataset.delayIndex) + 100)
                    .attr('opacity','1');
            p0.append('path')
                    .attr("d",fgArc2)
                    .attr("fill", zoneColors[1])
                    .attr("stroke","#666")
                    .attr("stroke-width",gaugeBorder)
                    .attr('opacity','0')
                    .transition()
                    .duration(300)
                    .delay(1200 * (dataset.delayIndex) + 400)
                    .attr('opacity','1');
            p0.append('path')
                    .attr("d",fgArc3)
                    .attr("fill", zoneColors[2])
                    .attr("stroke","#666")
                    .attr("stroke-width",gaugeBorder)
                    .attr('opacity','0')
                    .transition()
                    .duration(300)
                    .delay(1200 * (dataset.delayIndex) + 700)
                    .attr('opacity','1');
            p0.append('path')
                    .attr("d",fgArc4)
                    .attr("fill", zoneColors[3])
                    .attr("stroke","#666")
                    .attr("stroke-width",gaugeBorder)
                    .attr('opacity','0')
                    .transition()
                    .duration(300)
                    .delay(1200 * (dataset.delayIndex) + 1000)
                    .attr('opacity','1');

            var pt0 = p0.append('g').data([lineData]);
    
            var pointer = pt0.append('path')
                .attr("fill",zoneColors[0])
                .attr('d', pointerLine )
                .attr('class', 'pointer')
                .attr("stroke",zoneColors[0])
                .attr("stroke-width","5")
                .attr('transform', 'rotate(' + minAngle +')');

            var numberBox = p0.append("g");
            numberBox.append('circle')
                    .attr('fill',"#666")
                    .attr('r', numberRadius)
                    .attr("cx", 0)
                    .attr("cy", 0);
            var numberSpan = numberBox.append('text')
                    .text("0")
                    .attr("fill", "#fff")
                    .attr("text-anchor", "middle")
                    .attr("font-size","36")
                    .attr("dy","10")
                    .attr("data-val", dataset.targetValue)
                    .attr('class', 'number-span');

            // delay pointer untill all segments are drawn
            pointer.transition()
                .delay(1200 * (dataset.delayIndex + 1))
                .duration(1000)
                .attr('transform', 'rotate(' + zoneAngles[dataset.targetZone] +')');
        
        
            chartWrapper.select(".number-span")
                .transition()
                .delay(1200 * (dataset.delayIndex + 1))
                .duration(1000)
                .on("start", function repeat() {
                  d3.active(this)
                      .tween("text", function() {
                        var that = d3.select(this),
                            endVal = that.attr('data-val'),
                            i = d3.interpolateNumber(that.text(), endVal);
                        return function(t) { that.text(format(i(t))); };
                      })
                    .transition();
                });
            
     
            // do tooltip div
            div.style('background-color', zoneColors[dataset.targetZone]);
            div.style('border-color', zoneColors[dataset.targetZone]);
            div.html("<p style='color:#fff;font-size:10px;'>" + dataset.tooltipText + "</p>");
    
            $(document).on('mouseup mouseenter touchend', gDiv, [], function(e){
                // Hover over code
                e.stopPropagation();
                e.preventDefault();
                        var statY = 0,
                    statX = '50%';
                var ttBox = div.node().getBoundingClientRect();
                if ($(gDiv + ' .tooltip-c').hasClass('open')) {
                    $(gDiv + ' .tooltip-c')
                        .removeClass('open')
                        .css('transition',"opacity .3s ease, margin-top .3s ease")
                        .css('margin-top', "0")
                        .css('opacity',"0");
                } else {
                    $(gDiv + ' .tooltip-c')
                        .addClass('open')
                        .css('opacity', "1")
                        .css('transition', "opacity .3s ease, margin-top .3s ease")
                        .css({ 'top': '0', 'left': '50%'})
                        .css('margin-top', "-10px")
                        .css('margin-left', - ttBox.width/2);
                }
                return false;
            })
            
            .on('mouseout', gDiv, [], function() {
                // Hover out code
                $(gDiv + ' .tooltip-c')
                    .removeClass('open')
                    .css('transition',"opacity .3s ease, margin-top .3s ease")
                    .css('margin-top', "0")
                    .css('opacity', "0");
            });
        }

        return function initGaugeChart(args) {
            return args.IsExperienceEditorEditing ? null : new GaugeChart(
                args.scope,
                args.chartInfo,
                args.id);
        };
    });
